export default "__VITE_ASSET__CFeC_poB__"